import styled from 'styled-components';

export const AuthContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  ${(props) => props.isSafari > 0 && 'padding-bottom: 30px'};
`;

export const NavigationButton = styled.button`
  outline: none;
  border: none;
  background: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  svg {
    stroke: ${(props) => (props.isCurrent ? '#8C10FE' : '#4B4B4D')};
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: sticky;
  bottom: 0;
  background: #ffffff;
  padding: 18px 0px;
  z-index: 20;
  position: fixed;
  bottom: 0;
  left: 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

export const WatchChurchButton = styled.button`
  background: #222224;
  border-radius: 100px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  padding: 10px 16px;
  color: #ffffff;
  margin-left: 32px;
  display: flex;
  align-items: center;
  svg {
    margin-right: 4px;
  }
`;
